import { Box, Flex } from '@chakra-ui/react';
import { Tag, Text } from '@kula-ai/components';
import { useRegisterSuggestedActions } from '../floatingActions';
import type { SuggestedActionChipsProps } from './SuggestedActionChips.types';

// Shared suggested-action block — a "Suggested actions" title over a chip row.
// The one place every block renders follow-ups, so the header and primary-first
// sort stay consistent everywhere. The primary chip (the backend's "most
// obvious next click", e.g. the second half of a composite ask) always renders
// first, regardless of payload order. While a turn is in flight the whole row
// greys out — that alone reads as "busy", so no per-chip spinner.
export const SuggestedActionChips = ({
  actions,
  onSelect,
  disabled = false,
  testIdPrefix,
  title = 'Suggested actions',
  register = true,
}: SuggestedActionChipsProps) => {
  // Register for the floating bar; the floating copy passes register=false.
  const rowRef = useRegisterSuggestedActions({
    actions,
    onSelect,
    disabled,
    testIdPrefix,
    enabled: register,
  });
  if (actions.length === 0) return null;
  return (
    <Box ref={rowRef}>
      {title && (
        <Text variant="label" as="span" className="text-secondary-900">
          {title}
        </Text>
      )}
      <Flex wrap="wrap" gap="8px" mt={title ? '8px' : undefined}>
        {[...actions]
          .sort(
            (a, b) =>
              Number(b.kind === 'primary') - Number(a.kind === 'primary')
          )
          .map((a) => (
            <Tag
              key={a.id}
              label={a.label}
              size="md"
              variant={a.kind === 'primary' ? 'primary' : 'outline'}
              disabled={disabled}
              onClick={() => onSelect(a.promptTemplate)}
              className="cursor-pointer"
              data-test-id={`${testIdPrefix}-${a.id}`}
            />
          ))}
      </Flex>
    </Box>
  );
};
